<template>
  <div>
    <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
      <template #toggler>
        <CHeaderNavLink>
          <!-- <div class="c-avatar">
            <img src="img/avatars/user.png" class="c-avatar-img" />
          </div> -->
          <CIcon name="cil-settings" class="" />
        </CHeaderNavLink>
      </template>
      <!-- <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>Role</strong>
      </CDropdownHeader> -->
      <CDropdownItem v-for="(item, key) of $store.state.login_role" :key="key" @click="(ubahRole = item), $bvModal.show('modal-ubah-role')">
        <span :style="role_aktif.roleId == item.roleId ? 'color: green; font-weight: bold;' : ''">{{ item.namaRole }}</span>
      </CDropdownItem>
      <CDropdownHeader tag="div" class="text-left" color="light">
        <!-- <strong>Settings</strong> -->
      </CDropdownHeader>
      <CDropdownItem> <CIcon name="cil-settings" /> Options </CDropdownItem>
      <CDropdownItem @click="$bvModal.show('modal-logout')"> <CIcon name="cil-lock-locked" /> Logout </CDropdownItem>
    </CDropdown>
    <b-modal id="modal-ubah-role" size="md" centered title="Ubah Role" header-bg-variant="success" header-text-variant="light">
      <p>
        Apakah anda yakin akan mengubah role menjadi <span class="text-success">{{ ubahRole.namaRole }}</span> ?
      </p>

      <template #modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('modal-ubah-role')">
          {{ $store.state.form.tidak }}
        </b-button>
        <b-button variant="success" @click="pilihRole()"> Ya </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-logout" size="md" centered title="Logout" header-bg-variant="danger" header-text-variant="light">
      <p>Apakah anda yakin akan keluar dari akun ?</p>

      <template #modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('modal-logout')">
          {{ $store.state.form.tidak }}
        </b-button>
        <b-button variant="danger" @click="$router.push('/logout')"> Ya </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { removeToken } from "../store/utils/auth.js";
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      ubahRole: {},
    };
  },
  computed: {
    role_aktif() {
      return this.$store.state.role_aktif;
    },
  },
  watch: {
    "$store.state.role_aktif"(newVar, oldVar) {
      if (newVar != oldVar) {
        // console.log(newVar.namaRole)
      }
    },
  },
  async mounted() {
    console.log("store :", this.$store.state);
  },
  methods: {
    async pilihRole() {
      const vm = this;
      const x = vm.ubahRole;
      vm.$store.commit("set_role", x);
      const user = vm.$store.state.login_data_user;
      vm.$store.commit("set_mitra", user.mitraId ? { id: user.mitraId, namaMitra: user.namaMitra, namaApp: user.namaApp, logoApp: user.logoApp } : null);
      vm.$store.commit("set_koordinator", x.koordinatorId ? { id: x.koordinatorId, namaKoordinator: x.namaKoordinator } : null);
      vm.$store.commit("set_cabang", x.cabangId ? { id: x.cabangId, namaCabang: x.namaCabang } : null);
      vm.$store.commit("set_capem", x.capemId ? { id: x.capemId, namaCapem: x.namaCapem } : null);
      await vm.$router.push({ path: "/login" });
      await vm.$router.push({ path: "/dashboard" });
    },
    signout() {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      removeToken();
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>
